module.exports = __webpack_public_path__ + "img/1728525469738-image.jpg.fca76660.webp";